import gql from 'graphql-tag'
import client from '@stores/apollo'

const mutation = gql`
  mutation _($input: UpdateEmployeePasswordInput!) {
    updateEmployeePassword(input: $input) {
      status
    }
  }
`

function update(oldPassword: string, newPassword: string) {
  return client.gql
    .mutate({
      mutation,
      variables: { input: { oldPassword, newPassword } },
    })
    .then(
      ({
        data: {
          updateEmployeePassword: { status },
        },
      }: any) => status
    )
}

export default {
  update,
}
